<div class="formgrid grid mr-2" style="width: 150px;">
    <label>{{ compound }}</label>
    <div class="font-bold" *ngIf="alwaysVisible || showAlternativeName()">
        <div class="flex flex-column gap-2">
            <div class="label">
                <label [ngClass]="!isAlternativeNameValid && showAlternativeName() ? 'lbl-invalid' : 'lbl-valid'">{{ showAlternativeName() ? label + '*' : label }}</label>
            </div>
            <input 
                class="w-12" 
                [ngClass]="!isAlternativeNameValid && showAlternativeName() ? 'ng-invalid ng-dirty' : 'ng-valid'"
                pInputText 
                [id]="'alternativeNameInput'" 
                [(ngModel)]="alternativeCompoundName"
                [maxlength]="maxlength" 
                [pTooltip]="!hasSelectedModel() ? 'Select a model for this compound before adding an alternative name' : ''"
                tooltipPosition="top"
                (keypress)="omitIllegalCharactersInSubstanceNames($event)"
                (ngModelChange)="alternativeNameChanged($event)"
                [disabled]="disabled || !hasSelectedModel()"  />
        </div>
    </div>
</div>  